import React from 'react';
import './inventorycell.css';
import Card from 'react-bootstrap/Card';
import Stack from 'react-bootstrap/Stack';
import Row from 'react-bootstrap/Row';
import { Link, useLocation } from 'react-router-dom';
import { getInventoryItemPath } from '../../utils/urlPaths';

const InventoryCell = ({ item }) => {
    const location = useLocation();

  return (
    <div className="inventory-cell mx-auto py-4">
      <Card>
        <Link
          to={getInventoryItemPath(item)}
          className="inventory-cell-btn"
          style={{ textDecoration: 'none', color: 'inherit' }}
          state={{ previousLocation: location }}
        >
          <Card.Img
            loading="lazy"
            variant="top"
            src={`https://ohp.rockycoastlabs.xyz/${item.image_path1}`}
          />
          <Card.Body>
            <Card.Text className="cell-text">
              <Row>
                <div className="inventory-name-text justify-content-start d-flex pb-1">
                  {item.name}
                </div>
              </Row>
              <Row>
                <Stack direction="horizontal">
                  <div className="inventory-id">#{item.id}</div>
                  <div className="ms-auto">${item.price}</div>
                </Stack>
              </Row>
            </Card.Text>
          </Card.Body>
        </Link>
      </Card>
    </div>
  );
};

export default InventoryCell;
